<template>
    <div class="control-block polygon-legend-block">
        <ul>
            <li v-for="threshold of reversedThresholds" :key="threshold.value">
                <div class="polygon-legend__color" :style="{backgroundColor: threshold.color}"></div>
                <span v-if="(threshold.value=='データ欠損部')" class="polygon-legend__label">{{threshold.value}}</span>
                <span v-else="" class="polygon-legend__label">{{threshold.value}} ~</span>
            </li>
        </ul>
        <div v-if="this.sharedState.selectedDataType === 1">単位: 人/km<sup>2</sup></div>
        <div v-else>単位: 世帯/km<sup>2</sup></div>
    </div>
</template>

<script>
export default {
    name: 'polygon-legend',
    data () {
        return {
        }
    },
    created () {
    },
    computed: {
        sharedState () {
            return this.$store.state;
        },
        reversedThresholds () {
            return this.sharedState.thresholds.slice().reverse();
        }
    }
}
</script>

<style lang="scss" scoped>
.polygon-legend-block {

  .polygon-legend__color {
    display: inline-block;
    height: 14px;
    width: 14px;
    margin-right: 10px;
    // opacity: 0.5;
  }

  .polygon-legend__label {
    display: inline-block;
    line-height: 16px;
    vertical-align: top;
  }
}
</style>
